import PropTypes from 'prop-types';
import React from 'react';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { TabPanel } from 'react-tabs';
import { Body3 } from '../../../../../../../atomic/text/Text';
import style from './TacticsPanel.module.css';
import { colors } from '../../../../../../../../colorVars';
import { observer } from 'mobx-react-lite';
import { NotEngagedTacticRow } from './tacticRow/NotEngagedTacticRow';
import { EditIcon } from '../../../../../../../atomic/buttons/editIcon/EditIcon';
import { CancelOrderButton } from '../../../../../../../atomic/buttons/cancelOrderButton/CancelOrderButton';
import { PauseButton } from '../../../../../../../atomic/buttons/pauseButtons/PauseButton';
const tableColumns = ['Category', 'Tactic', 'Edit', 'Remove', 'Pause'];

export const TacticsPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const inPosition = tradePlan.inPosition;
    const positionTactics = tradePlan.positionTactics;
    const entryTactics = tradePlan.entryTactics;
    const exitTactics = tradePlan.exitTactics;
    const setupFilters = tradePlan.setupFilters;
    const setup = tradePlan.setup;

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table style={{ color: colors.lightGrey }} className={style.table}>
            <thead>
              <tr>
                {tableColumns.map((column) => {
                  if (column === 'Edit')
                    return (
                      <th key="Edit" className={style.buttonCell}>
                        <div className={style.buttonWrapper}>
                          <EditIcon
                            width={18}
                            height={18}
                            color={colors.orange}
                          />
                        </div>
                      </th>
                    );
                  if (column === 'Remove')
                    return (
                      <th key="Remove" className={style.buttonCell}>
                        <div className={style.buttonWrapper}>
                          <CancelOrderButton
                            width={18}
                            clickHandler={() => {}}
                          />
                        </div>
                      </th>
                    );
                  if (column === 'Pause')
                    return (
                      <th key="Pause" className={style.buttonCell}>
                        <div className={style.buttonWrapper}>
                          <PauseButton width={18} height={18} />
                        </div>
                      </th>
                    );
                  return (
                    <th key={column}>
                      <Body3 fontWeight={700}>{column}</Body3>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {!inPosition ? (
                <>
                  {Object.keys(entryTactics).map((tactic) => (
                    <NotEngagedTacticRow
                      key={tactic}
                      tradePlanId={tradePlanId}
                      category="Entry"
                      tacticName={tactic}
                      addTab={addTab}
                    />
                  ))}
                  {Object.keys(setupFilters).map((tactic) => (
                    <NotEngagedTacticRow
                      key={tactic}
                      tradePlanId={tradePlanId}
                      category="Setup Filter"
                      tacticName={tactic}
                      addTab={addTab}
                    />
                  ))}
                  {setup !== 'AD_HOC' ? (
                    <NotEngagedTacticRow
                      tradePlanId={tradePlanId}
                      category="Setup"
                      tacticName={setup}
                      addTab={addTab}
                    />
                  ) : null}
                </>
              ) : null}
              {Object.keys(positionTactics).map((tactic) => (
                <NotEngagedTacticRow
                  key={tactic}
                  tradePlanId={tradePlanId}
                  category="Position"
                  tacticName={tactic}
                  addTab={addTab}
                />
              ))}
              {Object.keys(exitTactics).map((tactic) => (
                <NotEngagedTacticRow
                  key={tactic}
                  tradePlanId={tradePlanId}
                  category="Exit"
                  tacticName={tactic}
                  addTab={addTab}
                />
              ))}
              <tr>
                <td
                  className={style.addTacticTd}
                  onClick={() => addTab('ADD_TACTIC', 'none')}
                >
                  <Body3 color={colors.green} fontWeight={700}>
                    Add Tactic
                  </Body3>
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </TabPanel>
    );
  }
);

TacticsPanel.propTypes = {
  addTab: PropTypes.any,
  tradePlanId: PropTypes.any,
};
TacticsPanel.tabsRole = 'TabPanel';

// {!inPosition ? (
//   <>
//     {softOrderIdArray &&
//       softOrderIdArray.map((id) => (
//         <SoftOrderWrapper
//           symbol="tacticsPanel"
//           key={id}
//           softOrderId={id}
//           addTab={addTab}
//           componentMap={detailsSectionRows}
//           {...rest}
//         />
//       ))}
//     {Object.keys(entryTactics).map((tactic) => (
//       <NotEngagedTacticRow
//         key={tactic}
//         tradePlanId={tradePlanId}
//         category="Entry"
//         tacticName={tactic}
//         addTab={addTab}
//       />
//     ))}
//     {Object.keys(positionTactics).map((tactic) => (
//       <NotEngagedTacticRow
//         key={tactic}
//         tradePlanId={tradePlanId}
//         category="Position"
//         tacticName={tactic}
//         addTab={addTab}
//       />
//     ))}
//     {Object.keys(exitTactics).map((tactic) => (
//       <NotEngagedTacticRow
//         key={tactic}
//         tradePlanId={tradePlanId}
//         category="Exit"
//         tacticName={tactic}
//         addTab={addTab}
//       />
//     ))}
//   </>
// ) : (
//   <>
//     {softOrderIdArray.map((id) => (
//       <SoftOrderWrapper
//         symbol="tacticsPanel"
//         key={id}
//         softOrderId={id}
//         addTab={addTab}
//         componentMap={detailsSectionRows}
//         {...rest}
//       />
//     ))}
//     {displayGrabCents ? (
//       <NotEngagedTacticRow
//         gcNoEditOrRemove={true}
//         tradePlanId={tradePlanId}
//         category="Exit"
//         tacticName="GRAB_CENTS"
//         addTab={addTab}
//       />
//     ) : null}
//   </>
// )}
